<template>
  <div class="form-group formways-component formways-button" :class="ctx.customClass" :id="ctx.key">
    <button type="button" class="btn" :class="[clsSize, clsTheme, clsBlock]" @click="onBtnClick">
      <template v-if="ctx.leftIcon"> <i :class="ctx.leftIcon"></i>&nbsp; </template>

      {{ this.ctx.label }}

      <template v-if="ctx.rightIcon"> &nbsp;<i :class="ctx.rightIcon"></i> </template>
    </button>
    <div class="form-text text-muted">
      {{ ctx.description }}
    </div>
  </div>
</template>

<script>
import SimpleComponentMixin from "../../mixins/SimpleComponentMixin";
import { executeScript } from "../../utils";
import defaultSchema from "./defaultSchema";

export default {
  name: "buttonComponent",
  mixins: [SimpleComponentMixin],
  beforeCreate() {
    // Default schema
    this.defaultSchema = defaultSchema;
  },
  methods: {
    onBtnClick() {
      if (this.ctx.action === "submit") {
        this.store.eventBus.$emit("form.submit");
      } else if (this.ctx.action === "reset") {
        this.store.eventBus.$emit("form.reset");
      } else if (this.ctx.action === "custom") {
        executeScript(this.ctx.custom, {
          data: this.formValues,
          context: this.context
        });
      } else if (this.ctx.action === "event") {
        this.store.eventBus.$emit("button.custom-event", this.ctx.event);
      }
    }
  },
  computed: {
    clsSize() {
      return `btn-${this.ctx.size}`;
    },
    clsTheme() {
      return `btn-${this.ctx.theme}`;
    },
    clsBlock() {
      if (this.ctx.block) return "btn-block";
      return "";
    }
  }
};
</script>
